import React from "react";

import WorkspaceLayout from "./WorkspaceLayout";
import { WORKSPACE_TYPES } from "../config/navigation";
import { useUser } from "../contexts/UserContext";

function mapCustomerWorkspaceUser(user) {
  return {
    ...user,
    role:
      user?.role === "super_admin" || user?.role === "admin"
        ? "owner"
        : user?.role || "owner"
  };
}

export default function CustomerLayout({ children }) {
  const { user } = useUser();

  const customerUser = mapCustomerWorkspaceUser(user);

  return (
    <WorkspaceLayout
      workspaceType={WORKSPACE_TYPES.CUSTOMER}
      title="Customer Workspace"
      subtitle="ESG reporting, documents, materiality, and AI advisory"
      user={customerUser}
    >
      {children}
    </WorkspaceLayout>
  );
}